import { bindAsyncAction } from '../../utils/sagas';
import { checkUserExist, userExists, userNotExists, login, requestResetPassword, register } from './actions';
import { checkUserClick, loginButtonClick, logoutButtonClick, registerButtonClick, requestPasswordClick, resetPhoneClick } from '../../components/Auth/actions';
import { apiRequest, checkUserExistRequest, apiAuthRequest, apiRefreshAuthRequest, resetPasswordRequest } from '../../utils/api';
import { fetchDevices, fetchDevicesStats } from "../devices/actions";
import { delay } from 'redux-saga';
import { push } from 'react-router-redux'
import { call, take, put, select, race, fork } from 'redux-saga/effects';
import * as authUtils from '../../utils/auth';
import decodeJwt from 'jwt-decode';

const loginWorker = bindAsyncAction(login, apiAuthRequest);
// const confirmRegisterWorker = bindAsyncAction(confirmRegister, apiAuthRequest);
const registerWorker = bindAsyncAction(
  register,
  function* postRegister(params) {
    return yield call(apiRequest, params);
  }
);
const refreshLoginWorker = bindAsyncAction(login, apiRefreshAuthRequest);
const checkUserExistWorker = bindAsyncAction(checkUserExist, checkUserExistRequest);
const sendPasswordWorker = bindAsyncAction(requestResetPassword, resetPasswordRequest);

export default function* authSaga() {
  yield fork(redirectAfterLoginSaga);
  let storedTokenInfo = authUtils.getStoredToken();

  while (true) {
    if (!storedTokenInfo) {
      yield fork(sendPasswordSaga);
      storedTokenInfo = yield call(registerLoop);
      yield call(authUtils.storeToken, storedTokenInfo);

    }

    const {signOutAction} = yield race({
      signOutAction: take(logoutButtonClick.type),
      authLoop: call(authLoop, storedTokenInfo),
    });

    if (signOutAction) {
      storedTokenInfo = null;
      yield call(authUtils.storeToken, storedTokenInfo);
    }
  }
}

function* redirectAfterLoginSaga() {
  while (true) {
    yield take(loginButtonClick.type);
    yield take(login.done.type);
    yield take(fetchDevicesStats.done.type);
    yield put(push('/'));
  }
}

function* registerLoop() {
  while (true) {
    // First step
    const { payload } = yield take(checkUserClick.type);
    let userRegistered = false;
    try {
      userRegistered = yield call(checkUserExistWorker, payload);
      if (userRegistered) {
        yield put({
          type: userExists.type,
        });
        return yield call(loginSaga);
      }
      yield put({
        type: userNotExists.type,
      });
      return yield call(registrationSaga);
    } catch (e) {
      continue;
    }
  }
}

function* loginSaga() {
  while (true) {
    const { loginClickAction, reset } = yield race({
      loginClickAction: take(loginButtonClick.type),
      reset: take(resetPhoneClick.type),
    });
    const phone = yield select(state => state.auth.phone);
    if (reset) throw new Error();
    // if (confirmRegisterClickAction) {
    //   try {
    //     yield call(confirmRegisterWorker, {
    //       phone,
    //       password: confirmRegisterClickAction.payload.password,
    //     });
    //   } catch (e) {
    //     continue;
    //   }
    //   const { payload } = yield take(loginButtonClick.type);
    //   try {
    //     return yield call(loginWorker, {
    //       phone,
    //       password: payload.password,
    //     });
    //   } catch (e) {
    //     continue;
    //   }
    // } else {
    try {
      return yield call(loginWorker, {
        phone,
        password: loginClickAction.payload.password,
      });
    } catch (e) {
      continue;
    }
    // }
  }
}

function* registrationSaga() {
  while (true) {
    const { registerClickAction, reset } = yield race({
      registerClickAction: take(registerButtonClick.type),
      reset: take(resetPhoneClick.type),
    });
    if (reset) throw new Error();
    const language = yield select(state => state.langs.currentLanguage);
    try {
      yield call(registerWorker, {
        url: '/api/v2/Register',
        method: 'POST',
        body: JSON.stringify(registerClickAction.payload),
        params: {
          Language: language,
        },
      });
      return yield call(loginSaga);
    } catch (e) {
      continue;
    }
  }
}

function* authLoop(tokenInfo) {
  while (true) {
    if (tokenInfo !== null) {
      const accessTokenInfo = decodeJwt(tokenInfo.access_token);
      const expiresIn = +accessTokenInfo.exp * 1000 - Date.now();
      if (expiresIn > 0) {
        yield put(login.done({params: void 0, result: tokenInfo}));
        // console.log('router next')
        // yield put(push('/'));
        yield call(delay, expiresIn);
      }
    }

    try {
      tokenInfo = yield call(refreshLoginWorker, tokenInfo);
      yield call(authUtils.storeToken, tokenInfo);
    } catch (e) {
      yield call(authUtils.storeToken, null);
      throw new Error(e);
    }
  }
}

function* sendPasswordSaga() {
  while (true) {
    yield take(requestPasswordClick.type);
    const phone = yield select(state => state.auth.phone);
    const language = yield select(state => state.langs.currentLanguage);

    try {
      yield call(sendPasswordWorker, {
        phone: phone,
        params: {
          Language: language,
        },
      });
    } catch (e) {
      continue;
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/auth/index.js